import React from 'react'
import css from "./About.module.css"

const About = () => {
  return (
    <div className={css.container} id='about'>


        <div className={css.wrap}>

        <span>About us</span>

        <span>Welcome to Maaya, your source for premium silk thread jewelry and quality raw materials. We're passionate about crafting exquisite silk thread jewelry, and we offer a wide range of top-notch materials to fuel your creativity. Whether you're a seasoned jewelry designer or a beginner, we're here to inspire and assist you in creating unique pieces that reflect your style. Join us on this creative journey and discover the art of silk thread jewelry making. </span>
  
         <span>Thank you for choosing Maaya for your crafting needs.</span>
        </div>
      
    </div>
  )
}

export default About
